<template>
  <v-container fluid class="tool-list-container">
    <!-- Tabs Section -->
    <v-row class="tabs" no-gutters>
      <v-col cols="6" class="tab-item">
        <v-btn
          class="tab"
          :class="{ active: activeTab === '最新上架' }"
          @click="changeTab('最新上架')"
          block
        >
          最新上架
        </v-btn>
      </v-col>
      <v-col cols="6" class="tab-item">
        <v-btn
          class="tab"
          :class="{ active: activeTab === '熱門精選' }"
          @click="changeTab('熱門精選')"
          block
        >
          熱門精選
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tools List -->
    <v-row class="tools">
  <v-col
    v-for="tool in tools"
    :key="tool.Codeno"
    cols="12"
    md="4"
    class="tool-item"
    :class="{ 'hovered': hoveredTool === tool.Codeno }"
    @mouseenter="onMouseEnter(tool.Codeno)"
    @mouseleave="onMouseLeave"
    @click="navigateToDetail(tool.Codeno)"
  >
    <div class="tool-content">
      <!-- Tool Classification -->
      <span 
  class="tool-class" 
  :class="{
    'application-tag': tool.工具大分類 === '應用工具',
    'development-tag': tool.工具大分類 === '開發工具',
    'model-tag': tool.工具大分類 === '語言模型'
  }"
>
  {{ tool.工具大分類 === '應用工具' ? '應用' : tool.工具大分類 === '開發工具' ? '開發' : tool.工具大分類 === '語言模型' ? '模型' : '未分類' }}
</span>


      <!-- Tool Name -->
      <span class="tool-name">{{ tool.Name }}</span>

      <!-- Tool Tags -->
      <div class="tool-tags">
        <span
          v-for="tag in tool.relatedUseCases.slice(0, 2)"
          :key="tag"
          class="tool-tag"
        >
          #{{ tag }}
        </span>
      </div>
    </div>
  </v-col>
</v-row>



  </v-container>
</template>





<script>
import axios from "axios";
import headerHelper from "@/utils/helpers/header";

export default {
  data() {
    return {
      activeTab: "最新上架", // Active Tab
      tools: [], // Tools List
      hoveredTool: null, // 當前鼠標所在工具的 ID
    };
  },
  methods: {
   // 當鼠標進入某工具時
   onMouseEnter(toolId) {
      this.hoveredTool = toolId; // 設置當前鼠標進入的工具 ID
    },
    // 當鼠標離開某工具時
    onMouseLeave() {
      this.hoveredTool = null; // 清空鼠標所在工具 ID
    },
    async fetchTools() {
      try {
        const headers = headerHelper.setHeader();
        const sortOrder = this.activeTab === "最新上架" ? 1 : 2;
        const baseUrl = process.env.VUE_APP_SERVICE_URL;

        // Fetch Tool List
        const response = await axios.get(
          `${baseUrl}/api/v1/searchPage/${sortOrder}`,
          {
            params: { page: 1, size: 10 },
            headers,
          }
        );

        if (response.data.rtnCode === "0000") {
          const toolsBasic = response.data.data;

          // Fetch Detailed Information
          const toolsDetailed = await Promise.all(
            toolsBasic.map(async (tool) => {
              try {
                const detailResponse = await axios.get(
                  `${baseUrl}/api/v1/tools/${tool.Codeno}`
                );
                if (detailResponse.data.rtnCode === "0000") {
                  const detailData = detailResponse.data.data;
                  return {
                    ...tool,
                    工具大分類: detailData.工具大分類 || "未分類",
                    relatedUseCases: detailData.relatedUseCases || [],
                  };
                } else {
                  console.error(
                    `Unable to fetch tool ${tool.Codeno}:`,
                    detailResponse.data.rtnMsg
                  );
                  return { ...tool, 工具大分類: "未分類", relatedUseCases: [] };
                }
              } catch (error) {
                console.error(`Request failed for tool ${tool.Codeno}:`, error);
                return { ...tool, 工具大分類: "未分類", relatedUseCases: [] };
              }
            })
          );

          this.tools = toolsDetailed;
        } else {
          console.error("API Error:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("Request failed:", error);
      }
    },
    changeTab(tabName) {
      this.activeTab = tabName;
      this.fetchTools();
    },
    navigateToDetail(toolId) {
      this.$router.push({ name: "CardDetail", params: { id: toolId } });
    },
  },
  created() {
    this.fetchTools();
  },
  mounted() {
  this.$emit('content-loaded'); // 當內容加載完成後通知父組件
},

};
</script>



<style scoped>
/* 應用工具 - 紅色底 白字 */
/* 工具大分類 - 標籤樣式 */
.tool-class {
  background-color: #e0e0e0; /* 替換為適合的背景顏色 */
  color: #333; /* 文字顏色 */
  font-size: 12px; /* 縮小字體大小 */
  font-weight: bold;
  padding: 2px 6px; /* 控制內邊距，僅覆蓋文字 */
  border-radius: 12px; /* 圓角效果 */
  display: inline-block; /* 確保背景適應文字內容 */
  line-height: 1; /* 行高控制 */
  text-align: center;
  margin-right: 5px; /* 增加右邊距離 */
}

/* 工具標籤 - 與右側標籤一致 */
.application-tag {
  background-color: #e57373 !important; /* 紅色 */
  color: white !important;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}

.development-tag {
  background-color: #64b5f6 !important; /* 藍色 */
  color: white !important;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}

.model-tag {
  background-color: #81c784 !important; /* 綠色 */
  color: white !important;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}



.tool-list-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
}
.tabs {
  display: flex;
  width: 100%; /* 確保寬度與工具一致 */
  margin: 0;
  padding: 0;
}

.tab-item {
  flex: 1; /* 讓兩個按鈕等分寬度 */
  margin: 0;
  padding: 0;
}

.tab-item {
  padding: 0;
}

.tab {
  font-size: 14px;
  color: #333;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  border-radius: 0; /* 去掉圓角 */
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s;
}
.tab.active {
  background-color: #4caf50;
  color: white;
}

.tools {
  display: flex;
  flex-direction: column;
  gap: 0px; /* 每項目間距 */
}

.tool-item {
  background: #ffffff;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  margin-bottom: 0px; /* 工具卡片之間無間隙 */
}

.tool-item.hovered {
  background-color: #f5f5f5; /* 鼠標移入時的背景顏色 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 鼠標移入時的陰影效果 */
}

.tools.hover-active .tool-item {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 所有工具都應用陰影效果 */
  background-color: #f9f9f9; /* 所有工具背景改變 */
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.tools.hover-active .tool-name {
  color: #4caf50; /* 所有工具的名稱顏色改變 */
}

.tools.hover-active .tool-tag {
  background-color: #c8e6c9; /* 改變標籤背景色 */
  color: #2e7d32; /* 改變標籤文字顏色 */
}


.tool-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tool-class {
  font-size: 14px;
  font-weight: bold;
  color: #6c757d;
  flex: 1; /* 左側寬度比例 */
}

.tool-name {
  font-size: 16px;
  color: #343a40;
  font-weight: 500;
  flex: 4; /* 中間寬度比例 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tool-tags {
  flex: 4; /* 右側寬度比例 */
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-start;
}

.tool-tag {
  background-color: #e7f3ff;
  color: #0056b3;
  font-size: 12px;
  padding: 0px 8px;
  border-radius: 12px;
  white-space: nowrap; /* 防止換行 */
}

/* 響應式設計 */
@media screen and (max-width: 768px) {
  .tool-content {
    flex-direction: column; /* 內容垂直排列 */
    align-items: flex-start; /* 靠左對齊 */
    gap: 10px;
  }

  .tool-tags {
    justify-content: flex-start;
  }
  .tool-item {
    height: 120px; /* 手機上高度較小 */
  }
}

@media screen and (max-width: 480px) {
  .tab {
    font-size: 12px;
    padding: 6px 12px;
  }

  .tool-item {
    font-size: 12px;
    padding: 10px;
    height: 100px; /* 更小螢幕下高度 */
  }

  .tool-tag {
    font-size: 10px;
    padding: 3px 6px;
  }
}

</style>
